import Http from "@/commons/Http";
import FrontBusiness from "@/business/FrontBusiness";

const CrudBusiness = (path) => ({
  async getById(id){
    return Http.get(`${path}/${id}`);
  },

  async getAll(resetCache = '') {
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getSimpleList() {
    return Http.get(`${path}/simple`);
  },

  async getSimpleListIds(ids) {
    return Http.post(`${path}/simple`, ids);
  },

  async getAllSimpleList() {
    return Http.get(`${path}/all-simple`);
  },

  async save(form, id = ''){
    return Http.post(`${path}/${id}`, form);
  },

  async delete(id){
    return Http.delete(`${path}/delete/${id}`).catch(e => FrontBusiness.showError('', e.message));
  }
});

export default CrudBusiness;
